export default __webpack_public_path__ + "static/media/close-modal.ee77012f.svg";